import { IMaterialDto } from "@/interfaces/IMaterialDto";

export class ProductBase{
    public IdProduct:string;
    public Code?: string;
    public OldCode:string;
    public Description:string;
    public TreeHierarchyCode:string;
    public Viscosity:string;
    public TechSpecs:string;
    public Approvals:string;
    public PerformanceLevel:string;
    public IsPublic:boolean;
    public ImportedFromSAP?:boolean;
    public Sperimental:boolean;
    public Edible:boolean;
    public NonfoodCompounds:string;
    public Materials?:IMaterialDto[];
    constructor(t?:any){
        if (t){
            Object.assign(this,t);
        }
    }
}